
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 44 44","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#71D3B9","d":"M21.937.445L39.4 8.883l4.313 18.96-12.086 15.204H12.245L.159 27.843l4.314-18.96z"}}),_c('path',{attrs:{"fill":"#0A294A","d":"M13.308 5.766l16-.08 10.039 12.5-3.483 15.669-14.38 7.037-14.45-6.893-3.64-15.632z"}}),_c('path',{attrs:{"d":"M21 13l7.071 2.929L31 23l-2.929 7.071L21 33l-7.071-2.929L11 23l2.929-7.071L21 13zm0 1.345l-6.12 2.536-2.535 6.118 2.536 6.12L21 31.653l6.118-2.536L29.654 23l-2.536-6.118L21 14.345zm-.633 3.77h1.182l-.074.44.485.085.156-.525h1.168c-.017.345-.142.654-.194.985.68.479 1.119 1.126 1.335 1.959l-1.696.41-.141-.354-1.142 4.684.194-.065a.675.675 0 00.08-.035c.34-.178.582-.457.751-.793.128-.272.212-.53.308-.822l1.668.53c-.208.798-.562 1.482-1.18 2.01-.626.535-1.381.72-2.198.77l-.145.492h-1.187l.12-.611-.47-.162-.204.773h-1.179l.01-.133a.457.457 0 01.01-.06l.204-.84c.033-.14.064-.282.09-.424l-.07-.078-.075-.077c-.575-.551-.876-1.246-1.046-2.008a5.92 5.92 0 01-.113-1.615c.037-.69.163-1.367.467-1.992.524-1.076 1.38-1.747 2.552-2.007.069-.016.136-.04.198-.058l.136-.48zm1.207 2.018l-.466-.105-.903 3.697c-.149.614-.297 1.228-.443 1.845l.45.228.054-.179.58-2.382c.234-1.038.535-2.059.728-3.104zm-1.791.293l-.042-.023-.184.145a.927.927 0 00-.084.08 2.098 2.098 0 00-.522 1.006c-.156.768-.206 1.567-.067 2.34l.043.002.856-3.55z","fill":"#FFF","fill-rule":"nonzero"}})])])
          )
        }
      }
    